import script from "./cpt-chart-map-migrate.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-chart-map-migrate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__